import { Validator } from '../../types/Validator';
import { ValidatorInterface } from '../../types/ValidatorInterface';
import { ValidatorRegistry } from '../../types/ValidatorRegistry';
import { PropertiesInterface } from '../../types/properties/Property';
import { ITypeValidatesRequiredIf } from './ITypeValidatesRequiredIf';

/**
 * @deprecated This class is deprecated and should not be used in new code.
 * Use RequiredIfValidator from application-types instead.
 */
export class RequiredIfValidator
  implements ValidatorInterface<ITypeValidatesRequiredIf> {
  name = 'RequiredIf';

  friendlyName = 'Required Field When';

  arrayOnly = false;

  array = false;

  description = 'shared.properties.validators.requiredIf.description';

  types = null;

  properties = {
    value: {
      type: 'Key',
      default: '',
      validators: [
        {
          name: 'Required',
          value: true,
        },
      ],
    },
  } as PropertiesInterface;

  attach(type: ITypeValidatesRequiredIf) {
    type.addRequiredIfValidator(this);
  }

  constructor(public config?: Validator) {}
}

/**
 * @deprecated This constant is deprecated and should not be used in new code.
 * Use RequiredIf from application-types instead.
 */
const RequiredIf = new RequiredIfValidator(undefined);

ValidatorRegistry.register(RequiredIfValidator, RequiredIf.name);

export default RequiredIf;
